import React from 'react';
import moment from 'moment';
import './SessionFooter.scss';

const SessionFooter: React.FC = () => {
  const user = JSON.parse(localStorage.getItem('user') ?? '{}');
  const userName = user.name || 'Sistema';

  return (
    <div className="sb-footer">
      <div className="sb-footer-row">
        <span>Fecha: {moment().format('DD-MM-YY HH:mm [a. m.]')}</span>
      </div>
      <div className="sb-footer-row">
        <span>Usuario: {userName}</span>
      </div>
    </div>
  );
};

export default SessionFooter;
